module.exports = __webpack_public_path__ + "static/media/unblock.bdf2c4ca.svg";